<div class="container" [ngClass]="state">
   <p><ng-content></ng-content></p>
</div>
